<div class="croppie-kontainer" data-testid="croppie-kontainer" #croppieKontainer>
    <!-- her tenger croppie seg ut-->
</div>

<!-- denne knappen flyttes til skalerings-slideren (som tegnes ut av croppie) via dom-manipulering i initCroppie()-metoden -->
<button mat-icon-button type="button" (click.stopp)="roter()" class="roter" matTooltip="{{'Roter bildet'|translate}}" #roterBildeKnapp>
  <mat-icon>rotate_right</mat-icon>
</button>

<!-- innhold fra forelder som vises så lenge nytt bilde ikke er valgt -->
<div class="eksisterende-bilde-kontainer">
  <ng-content></ng-content>
</div>
<bilde-velger [skjemakontroll]="valgtBildeSkjema"
              [maksStoerrelse]="maksAvatarStoerrelse"
              [velgBildeKnappDeaktivert]="velgBildeAktiv()"
              (vedBildeValgt)="bildeValgt($event)"
              (vedBildevelgerAktivert)="bildevelgerAktivert()">
    {{ knappetekst() }}
</bilde-velger>
@if(erBildeValgt()){
  <button mat-button type="button" (click)="tilbakestill()" class="tilbakestill">{{'Tilbakestill'|translate}}</button>
}
